<!-- DESKTOP -->
<span *ngIf="!isMobile" class="te-title" [innerHTML]="title" [ngClass]="{'te-title-big' : size == 'big', 'te-title-medium' : size == 'medium', 'te-title-small' : size == 'small'}"></span>
<!-- MOBILE -->
<span *ngIf="isMobile" class="te-title-mobile" [innerHTML]="title"></span>